module.exports = __webpack_public_path__ + "img/page11_logo.c917cd8b.png";